import {
  getGlobalSubscriptionState,
  getVariantData,
  track
} from '../../../analytics/shared';
import {
  ONE_CLICK_CHECKOUT_BUTTON,
  ADD_TO_CART_BUTTON
} from '../../../classnames/design-system';
import { getPageURLWithoutQueryParams } from '../../../utils/get-page-url';

// Google Tag Manager event on purchase CTA click
export default class PurchaseSectionAnalytics {
  constructor(container) {
    this.container = container;
  }

  handleClick(event) {
    if (event.target.classList.contains(ONE_CLICK_CHECKOUT_BUTTON)
      || event.target.classList.contains(ADD_TO_CART_BUTTON)) {
      if (window.dataLayer) {
        const { variantId, localSubscriptionState } = event.target.dataset;
        const { productTitle, variantTitle } = getVariantData(variantId);
        const globalSubscriptionState = getGlobalSubscriptionState();
        const currentSubscriptionState = localSubscriptionState || globalSubscriptionState;

        track({
          eventName: 'purchase_section_CTA_click',
          data: {
            purchase_section: {
              page_url: getPageURLWithoutQueryParams(),
              product: productTitle,
              variant: variantTitle,
              purchase_type: currentSubscriptionState
            }
          }
        });
      }
    }
  }

  initializeEventListeners = () => {
    if (!this.container) { return; }

    this.container.addEventListener('click', this.handleClick);
  };
}
